import { Component, Input, inject } from '@angular/core';
import { wordDeclensions } from 'src/app/shared/constants';
import { TextSizes, TextType } from 'src/app/shared/enums';
import { IDepartment } from 'src/app/shared/services/posts/posts.type';
import { LinkNav } from 'src/app/shared/interfaces';
import { UtilsService } from 'src/app/shared/services/utils.service';

import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { ImageComponent } from '../image/image.component';
import { TextComponent } from '../text/text.component';
import { AddBaseUrlPipe } from '../../pipe/add-baseUrl/add-base-url.pipe';
import { WordDeclensionPipe } from '../../pipe/word-declension/word-declension.pipe';
@Component({
  selector: 'app-department-card',
  templateUrl: './department-card.component.html',
  styleUrls: ['./department-card.component.scss'],
  imports: [
    IonicModule,
    RouterLink,
    ImageComponent,
    TextComponent,
    AddBaseUrlPipe,
    WordDeclensionPipe,
  ],
})
export class DepartmentCardComponent {
  utils = inject(UtilsService);

  @Input() department: IDepartment | undefined;

  @Input() departmentUrl?: LinkNav['link'];

  readonly TextSizes = TextSizes;

  readonly TextType = TextType;

  readonly employeesDeclension = wordDeclensions.employees;
}
